











































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeaderMenu from '@/app/components/Common/Header/HeaderMenu.vue'
import Local from '@/app/module/local'

@Component({
  components: {
    HeaderMenu
  }
})
export default class Header extends Vue {
  private isShowMenu:boolean = false
  private isAuth:boolean = false
  private isAdmin:boolean = false
  private userType:string|null = ''
  private userName:string|null = ''

  @Watch('$route')
  changePath (newValue: any) : void {
    if (newValue.name === 'field') {
      this.setDetail()
    }
  }

  created () {
    this.setDetail()
  }

  private setDetail () {
    if (Local.getAuthToken()) {
      this.isAuth = true
    }

    if (Local.getUserName()) {
      this.userName = Local.getUserName()
    } else {
      this.userName = '名無し'
    }

    if (Local.getUserType()) {
      switch (Local.getUserType()) {
        case '1':
          this.userType = '圃場作業者'
          break

        case '2':
          this.userType = '圃場管理者'
          break

        case '0':
          this.userType = '経営者'
          this.isAdmin = true
          break

        default:
          break
      }
    }
  }

  private showMenu () {
    if (this.isShowMenu) {
      this.isShowMenu = false
    } else {
      this.isShowMenu = true
    }
  }
}
